import React from 'react';
import styles from './LinearProgress.module.css';

function LinearProgress({ value = 0, height }) {
  const style = {};

  if (height != null) {
    style.height = `${height}px`;
  }

  return (
    <div className={styles.root} style={style}>
      <div className={styles.bar} style={{ ...style, transform: `translateX(${value - 100}%)` }} />
    </div>
  );
}

export default LinearProgress;
